import React, { FC } from 'react';
import { CallSttFragmentType } from 'store/calls/calls.types';
import { timeConverter } from 'utils/convertDateAndTime/dateTimeFormating';
import useStyles from './styles.jss';
import { DialogItemType } from './types';
import TextLineLayout from './TextLineLayout';

const DialogItem: FC<DialogItemType> = ({ callId, prevFragment, fragmentIndex, phrase, audioPlayerRef }) => {
	const classes = useStyles();
	const condition = phrase.direction === 'client';
	const time = timeConverter(phrase.begin, false);

	const prevChatFragment = prevFragment as CallSttFragmentType;
	const speaker =
		prevChatFragment && (prevChatFragment.speaker_name !== phrase.speaker_name ? phrase.speaker_name : '');
	const speakerNameStyles = condition ? classes.titleCustomer : classes.titleEmployee;

	return (
		<TextLineLayout
			time={time}
			speaker={speaker || ''}
			callId={callId}
			fragmentIndex={fragmentIndex}
			words={phrase.words}
			highlightIndexes={phrase.highlight_words_indexes}
			handleWordClick={(i: number) => {
				audioPlayerRef.current.audioEl.current.play();
				audioPlayerRef.current.audioEl.current.currentTime = phrase.words[i].begin / 1000 + 0.01;
			}}
			speakerClassName={classes.chatTitle}
			timeClassName={classes.chatTime}
			colorClassName={speakerNameStyles}
			lineStartPadding="0"
		/>
	);
};

export default React.memo(DialogItem);
